import { SwiperSlide } from 'swiper/react'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { EffettoCard } from '@components/molecules'
import { WCONT_MD } from '@utils/settings'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { GenericSection, GenericSlider } from '@components/organisms'
import styles from './EffettiSection.module.sass'

interface Props {
  effetti?: any[] // TODO
  item?: MenuItemType
  theme?: GenericSectionThemeType
  className?: string
}

const EffettiSection = (props: Props) => {
  const { effetti = [], item = undefined, theme = 'white', className = '' } = props

  return effetti?.length ? (
    <GenericSection theme={theme} item={item} className={`${styles.root} ${className}`}>
      <GenericSlider
        id="effetti_banner"
        conf={{
          modules: [Navigation, A11y, Pagination],
          slidesPerView: 'auto',
          pagination: {
            clickable: true,
          },
          navigation: true,
          spaceBetween: 20,
          breakpoints: {
            [WCONT_MD]: {
              slidesPerView: 8,
            },
          },
        }}
        navigationPos="pagination"
        className={styles.slider}
      >
        {effetti.map((item, idx) => (
          <SwiperSlide key={idx}>
            <EffettoCard item={item} />
          </SwiperSlide>
        ))}
      </GenericSlider>
    </GenericSection>
  ) : (
    <></>
  )
}

export default EffettiSection
